import '../../../styles/restScreens.css';
import ContactNameFields from '../../shared/ContactNameFields';
import LabeledMultiField from '../../shared/LabeledMultiField';
import { emptyEntry, entriesOf } from '../../../lib/contactMethods';

// BL-177 PR D8: a My Contact uses the SAME labeled multi-phone / email / address model as a company contact (Mobile / Work / Home /
// Other, one Primary per kind). Used by the Add dialog's "My Contacts" choice and by the My Contact card's editor.

export const blankPersonalDraft = () => ({
    name: '', company_name: '', position: '', notes: '',
    phones: [{ ...emptyEntry('phone'), is_primary: true }],
    emails: [{ ...emptyEntry('email'), is_primary: true }],
    addresses: [{ ...emptyEntry('address'), is_primary: true }],
});

export const draftFromPersonal = (contact) => ({
    name: contact?.name || '', company_name: contact?.company_name || '', position: contact?.position || '', notes: contact?.notes || '',
    phones: entriesOf(contact, 'phone'), emails: entriesOf(contact, 'email'), addresses: entriesOf(contact, 'address'),
});

const field = `w-full px-3 py-2 rounded-lg border outline-none focus:ring-2 focus:ring-brand-500
               bg-[var(--surface-sunken)] border-[var(--surface-border)] text-[var(--ink)] placeholder-[var(--ink-muted)]`;
const label = 'block text-xs font-semibold mb-1 text-[var(--ink-muted)]';

export default function PersonalContactForm({ draft, onChange, disabled = false, idPrefix = 'my-contact' }) {
    const set = (key, value) => onChange({ ...draft, [key]: value });
    return (
        <div data-m6-layout="clients" data-m6-component="PersonalContactForm" className="grid gap-3 sm:grid-cols-2" data-testid="personal-contact-form">
            <div>
                <ContactNameFields value={draft.name} onChange={value => set('name', value)} className={field} labelClassName={label} disabled={disabled} idPrefix={idPrefix} />
            </div>
            <div>
                <label className={label} htmlFor={`${idPrefix}-company`}>Company</label>
                <input id={`${idPrefix}-company`} className={field} value={draft.company_name} disabled={disabled} onChange={e => set('company_name', e.target.value)} />
            </div>
            <div>
                <label className={label} htmlFor={`${idPrefix}-position`}>Position</label>
                <input id={`${idPrefix}-position`} className={field} value={draft.position} disabled={disabled} onChange={e => set('position', e.target.value)} />
            </div>
            <div>
                <label className={label} htmlFor={`${idPrefix}-notes`}>Notes</label>
                <input id={`${idPrefix}-notes`} className={field} value={draft.notes} disabled={disabled} onChange={e => set('notes', e.target.value)} />
            </div>
            <div>
                <label className={label}>Phone</label>
                <LabeledMultiField kind="phone" ariaLabel="Phone" entries={draft.phones} disabled={disabled} onChange={rows => set('phones', rows)} />
            </div>
            <div>
                <label className={label}>Email</label>
                <LabeledMultiField kind="email" ariaLabel="Email" entries={draft.emails} disabled={disabled} onChange={rows => set('emails', rows)} />
            </div>
            <div className="sm:col-span-2">
                <label className={label}>Address</label>
                <LabeledMultiField kind="address" ariaLabel="Address" entries={draft.addresses} disabled={disabled} onChange={rows => set('addresses', rows)} />
            </div>
        </div>
    );
}
